import React from 'react';
import {Field, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import {MoneyField} from 'components/Fields';

import {required} from 'utils/validators';

const formSelector = formValueSelector('createBooking');

export const initialValues = state => {
  const rentPerWeekValue = formSelector(state, 'rentPerWeek');
  const roomDepositValue = formSelector(state, 'roomDeposit');
  const selectedRoomType = formSelector(state, 'roomType');

  return {
    rentPerWeek:
      (selectedRoomType && selectedRoomType.object.defaultPwRent) ||
      rentPerWeekValue,
    roomDeposit:
      (selectedRoomType && selectedRoomType.object.defaultRoomDeposit) ||
      roomDepositValue
  };
};

const RentAndDepositSection = () => (
  <div>
    <FormField>
      <Label>Rent Per Week</Label>
      <Field name="rentPerWeek" validate={[required]} component={MoneyField} />
    </FormField>
    <FormField>
      <Label>Room Deposit</Label>
      <Field name="roomDeposit" validate={[required]} component={MoneyField} />
    </FormField>
  </div>
);

export default RentAndDepositSection;
